import React, { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@smiles/voebiz-ui-kit';
import ModalInclude from 'components/ModalInclude';

import EmptyCloudIcon from '../Icons/EmptyCloudIcon';
import BaggageIcon from '../Icons/BaggageIcon';

export type ErrorTeamProps = {
  title: string | undefined;
  description: string | undefined;
  isSearchError: boolean;
};

const ErrorTeam: FC<ErrorTeamProps> = ({ title, description, isSearchError }) => {
  const { t } = useTranslation(['beneficiaries', 'errorNoTeam']);
  const [openModalInclude, setOpenModalInclude] = useState(false);
  const [typeInclude, setTypeInclude] = useState('one');

  const handleCloseModalInclude = () => {
    setOpenModalInclude(false);
  };

  const handleOpenModalMilesBatch = (type: string) => {
    setOpenModalInclude(true);
    setTypeInclude(type);
  };
  const handleRegisterTeam = () => {
    window.location.href = 'https://voebiz.smiles.com.br/beneficiarios';
  };

  return (
    <div className="no-team-container">
      <div className="center">
        <div className="img-baggage-container">{isSearchError ? <BaggageIcon /> : <EmptyCloudIcon />}</div>
        <div className="no-team-col-container">
          <div className="no-team-title-container">
            <h3 className="no-team-title">{title}</h3>
          </div>
          <div className="no-team-description-container">
            <p className="no-team-description">{description}</p>
          </div>
          {!isSearchError && (
            <div className="empty_miles_btn_wrapper">
              <Button className="button-send-miles btn-common-actions" onClick={() => handleOpenModalMilesBatch('one')}>
                {t('include_team_text')}
              </Button>
              <Button className="button-register-team btn-common-actions" onClick={handleRegisterTeam}>
                {t('register_team')}
              </Button>
            </div>
          )}
        </div>
      </div>
      <ModalInclude
        isOpen={openModalInclude}
        closeModal={handleCloseModalInclude}
        setTab={setTypeInclude}
        type={typeInclude}
      />
    </div>
  );
};

export default ErrorTeam;
